import React, { Component } from "react";
import logo2 from "../assets/logo2.png";

class SeminarMasakatsu2 extends Component {
  state = { registered: {} };

  seminar = "masakatsu"; // ✅ unique seminar key for backend

  componentDidMount() {
    this.fetchRegistered();
    // Optional: auto-refresh every 10 seconds to sync everyone
    this.interval = setInterval(this.fetchRegistered, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  // ✅ Fetch current registration data from backend
  fetchRegistered = async () => {
    try {
      const res = await fetch(`/api/registered?seminar=${this.seminar}`);
      const data = await res.json();
      this.setState({ registered: data });
    } catch (err) {
      console.error("Failed to fetch registered participants:", err);
    }
  };

  // ✅ Handle click: register or unregister
  handleRegister = async (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      // 🔐 Unregister with PIN
      const pin = window.prompt("Enter PIN to unregister:");
      const res = await fetch("/api/unregister", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ seminar: this.seminar, id, pin }),
      });

      if (res.ok) {
        const data = await res.json();
        this.setState({ registered: data });
        alert("Unregistered successfully.");
      } else {
        alert("Incorrect PIN. Unregister cancelled.");
      }
    } else {
      // ✅ Register participant
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        const res = await fetch("/api/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ seminar: this.seminar, id }),
        });
        const data = await res.json();
        this.setState({ registered: data });
      }
    }
  };

  // ✅ Render a participant entry
  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue", // 🔵 not registered / 🔴 registered
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className="RosterTuesday1">
        <h3>Masakatsu Dojo Participants Day 2</h3>
        <br />
        <br />

        {this.renderParticipant(1, "Ms. Pawanrat Chupinijsak")}
        <br />

        <div>ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...</div>
        <br />
        <br />
        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarMasakatsu2;
